module.exports = {"id":"212245","name":"Yannick Gerhardt","rating":"75","photo":"./data/images/photos/0/212245.png","club":{"name":"VfL Wolfsbourg","logo":"./data/images/clubs/VfLWolfsbourg.png"},"positions":["DG","MG","MC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/YannickGerhardt0.json
// module id = 4389
// module chunks = 0